module.exports = __webpack_public_path__ + "static/media/anumatiLogo.72e1b5bf.jpg";